import React from "react";
import { ArrowDown } from "lucide-react";
import { Button } from "../ui/button";

// Strong conversion band placed directly before the protected quote form.
// Solid Tasklio green so it reads as a deliberate break between the business
// story above and the quote form below. Only rendered when the mini-site has
// content sections above it.
export const PublicQuoteCTA = ({ t, onGetQuote }) => (
  <section
    className="rounded-2xl bg-green-800 p-8 sm:p-10 lg:p-14 mb-5 lg:mb-8 text-center"
    data-testid="public-quote-cta-section"
  >
    <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-semibold text-white tracking-tight">
      {t("public.cta.title")}
    </h2>
    <p className="mt-3 text-green-100 lg:text-lg max-w-xl mx-auto">{t("public.cta.subtitle")}</p>
    <Button
      onClick={onGetQuote}
      className="mt-6 h-12 px-8 bg-white hover:bg-green-50 text-green-900 text-base font-semibold w-full sm:w-auto"
      data-testid="public-cta-get-quote-button"
    >
      {t("public.hero.getQuote")} <ArrowDown className="w-4 h-4 ml-1.5" />
    </Button>
  </section>
);
